module.exports = __webpack_public_path__ + "img/favicon.d18b6efa.png";